import { render, staticRenderFns } from "./UploadHistoryTable.vue?vue&type=template&id=1056246a"
import script from "./UploadHistoryTable.vue?vue&type=script&lang=js"
export * from "./UploadHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports